<template>
  <v-dialog v-model="dialog" width="800px">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        v-on="on"
        class="mb-2 primary"
        depressed
        :disabled="!isAdmin"
      >
        Group Message
      </v-btn>
    </template>
    <v-card tile>
      <v-card-title>New Group Message</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 pb-5">
        <v-form v-model="valid" ref="form">
          <v-autocomplete
            outlined
            label="Select Group"
            item-text="name"
            item-value="users"
            dense
            @change="onGroupChange"
            :items="technicianGroups"
            v-model="groups"
          ></v-autocomplete>
          <v-autocomplete
            outlined
            :rules="multiple"
            label="Technicians"
            item-text="name"
            item-value="phone"
            dense
            @change="onChange"
            :search-input.sync="search"
            multiple
            chips
            small-chips
            :items="list"
            v-model="phones"
          ></v-autocomplete>
          <v-file-input
            class="file__input"
            outlined
            v-model="file"
            label="Attach Image"
            dense
            prepend-inner-icon="mdi-image"
            accept="image/*"
          >
            <template v-slot:prepend> </template>
          </v-file-input>
          <v-textarea v-model="message" :rules="rules" label="Message" outlined>
          </v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" @click="dialog = false" text>Cancel</v-btn>
        <v-btn color="success" @click="submit()" text>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate, resizeFile } from "../../assets/js/common";
import { functions } from "../../assets/js/firebase";
export default {
  data() {
    return {
      valid: false,
      search: "",
      dialog: false,
      phones: [],
      groups: [],
      message: "",
      media: "",
      file: null,
      multiple: [v => v.length != 0 || "Field is required."]
    };
  },
  computed: {
    rules() {
      return [v => !!v || this.file != null || "Field is required."];
    },
    list() {
      return this.$store.getters.technicians;
    },
    technicianGroups() {
      return this.$store.getters.technicianGroups;
    }
  },
  methods: {
    onChange() {
      this.search = "";
    },
    onGroupChange() {
      this.phones = this.groups;
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      let { message, phones, file } = vm;
      if (!vm.valid) return;

      let updated_at = getDate();
      try {
        vm.$root.loader = true;
        let doc = {
          text: message,
          updated_at,
          phones
        };
        if (file) {
          doc.media = await resizeFile(file);
        }
        let { data } = await functions.httpsCallable("sendTechnicianGroupSMS")(
          doc
        );
        if (!data.status) {
          vm.$root.alert(data.message);
        } else {
          vm.dialog = false;
          vm.message = "";
          vm.file = null;
          vm.phones = [];
        }
        vm.$root.loader = false;
      } catch (error) {
        console.log(error);
        vm.$root.alert(error.message);
        vm.$root.loader = false;
      }
    }
  }
};
</script>

<style lang="scss">
.file__input {
  .v-input__prepend-outer {
    display: none !important;
  }
}
</style>
